<template>
    <div class="content">
        <br>
        <p>{{ infotext }}</p>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"
    import SearchResultModel from "@/models/searchresultmodel"
    import { store } from '@/store/store'

    @Component
    export default class KiinteanVerkonSaatavuusRuuduilla extends Vue {
        get infotext(): string | undefined {
            if (this.searchAddressSelected !== null) {
                return this.$t("App.KiinteanLaajakaistaverkonSaatavuusRuuduilla.RightSlot.InfoText") + " " + this.searchAddressSelected.getFullName() + "."
            }
            return this.$t("App.LaajakaistaJaPuhelin.KVSaatavuusRuuduillaInfoText")
        }

        get searchAddressSelected(): SearchResultModel | null {
            return store.getters.searchAddressSelected
        }
    }
</script>
